///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = abcsetup.dashboard || {};
abcsetup.dashboard.sps_buyer = abcsetup.dashboard.sps_buyer || {};
abcsetup.dashboard.sps_buyer.rx = abcsetup.dashboard.sps_buyer.rx || {};
abcsetup.dashboard.sps_buyer.frontstore = abcsetup.dashboard.sps_buyer.frontstore || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard.sps_buyer = {
    init: function() {
        // Outstanding items delete button clicked
        $(document).on('click', '#sps_buyer_panel .btn-delete-workflow', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Workflow Task', 'Are you sure you want to delete this workflow task?', function (resp) {
                if (resp) {
                    abcsetup.dashboard.sps_buyer.deleteWorkflow(_this.data('id'));
                }
            });
        });

        // Delete button clicked
        $(document).on('click', '#new_rx_items .btn-delete', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Item', 'Are you sure you want to delete this item?', function (resp) {
                if (resp) {
                    abcsetup.dashboard.sps_buyer.rx.delete(_this.data('id'));
                }
            });
        });

        // Non-Rx delete button clicked
        $(document).on('click', '#new_non_rx_items .btn-delete', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Item', 'Are you sure you want to delete this item?', function (resp) {
                if (resp) {
                    abcsetup.dashboard.sps_buyer.frontstore.delete(_this.data('id'));
                }
            });
        });
    },

    /**
     *
     */
    deleteWorkflow: function(id) {
        abcsetup.dashboard.showLoading($('#sps_buyer_panel'));
        $('#sps_buyer_panel').find('.dataTables_wrapper').hide();

        axios.delete('/api/workflow_task/' + id).then(response => {
            window.location.reload();
        });
    },


    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  Rx Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    rx: {
        delete: function(id) {
            abcsetup.dashboard.showLoading($('#new_items_panel'));
            $('#new_items_panel').find('.dataTables_wrapper').hide();

            axios.delete('/rx_item/' + id).then(response => {
                window.location.reload();
            });
        },
    },


    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  Frontstore Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    frontstore: {
        delete: function(id) {
            abcsetup.dashboard.showLoading($('#new_items_panel'));
            $('#new_items_panel').find('.dataTables_wrapper').hide();

            axios.delete('/front_store/' + id).then(response => {
                window.location.reload();
            });
        },
    },
}
